module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "performance_vis.fb76a3b6.svg";